export const DEFAULT_SCENE = 'schedule-adherence:history';
export const TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const CONTAINER_TAG = `${DEFAULT_SCENE}:container`;
const SEARCH_ADHERENCE_HISTORY = `${DEFAULT_SCENE}:filter-adherence`;
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;

const LIST = `${DEFAULT_SCENE}:list`;
export const LIST_CONTAINER_TAG = `${LIST}:container`;
export const getListHeaderTag = (headerName: string) => `${LIST}:header-${headerName}`;
export const getListItemTag = (order: number, propName: string) => `${LIST}:historyItem[${order}]-${propName}`;

const AGENT_DETAILS = `${DEFAULT_SCENE}:agent-details`;
export const AGENT_DETAILS_CONTAINER_TAG = `${AGENT_DETAILS}:container`;
export const getAgentDetailsItemTag = (propName: string) => `${AGENT_DETAILS}:${propName}`;

export const SEARCH_ADHERENCE_HISTORY_HEADER_CONTAINER_TAG = `${SEARCH_ADHERENCE_HISTORY}:header-container`;
export const REFRESH_BUTTON_TAG = `${DEFAULT_SCENE}:button-refresh`;

// SideBar Filter
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_ADHERENCE_HISTORY_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;

export const getFilterInputTag = (name: string, type: string) => `${FILTER_SIDEBAR}:${type}-input-${name}`;
export const getFilterInputResetTag = (name: string, type: string) =>
  `${FILTER_SIDEBAR}:${type}-input-reset-button-${name}`;
